











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class UPercentageChange extends Vue {
  // Props
  @Prop({ default: 0 })
  public value!: number;

  @Prop({ default: true })
  public withBackgroud!: boolean;

  // Computed
  public get percentage() {
    return this.$_.compact([
      this.value > 0 && "↑",
      this.value < 0 && "↓",
      `${this.value}%`.replace(/^-/g, "")
    ]).join(" ");
  }
  public get classes() {
    if (this.value > 0) return "is-positive-change";
    if (this.value < 0) return "is-negative-change";
    return "";
  }
}
